import React, { useState } from "react";
import { FaPen } from "react-icons/fa";
import { MdKeyboardArrowRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ModalStructure from "../ModalStructure";
import ProductClassForm from "../../screens/ProductClasses/ProductClassForm";
import { IS_LOCAL_ENV } from "../../App";

const ProductClassCard = ({ info, loadToParent }) => {
  const [showClassForm, setShowClassForm] = useState(false);
  const navigate = useNavigate();

  IS_LOCAL_ENV && console.log("info", info);

  return (
    <>
      <div
        className="flex flex-col w-fit relative rounded-xl border-[1px] border-color-accent-green p-4 bg-white hover:cursor-pointer hover:bg-green-50 transition-all hover:scale-105 duration-300 h-fit gap-y-2 font-poppins hover:shadow-md"
        onClick={() => navigate(`${info.id}`)}
      >
        <button
          className="p-2 absolute right-2 top-2 rounded-full text-accent-green hover:bg-green-50 transition-all duration-100"
          onClick={(e) => {
            e.stopPropagation();
            setShowClassForm(true);
          }}
        >
          <FaPen />
        </button>
        <img
          src={`${process.env.REACT_APP_SERVER}${info.image.url}`}
          className="h-[200px] rounded-t-xl"
        />
        <div className="flex flex-row items-center justify-center gap-y-2">
          <h3>{info.name}</h3>
          <MdKeyboardArrowRight />
        </div>
      </div>
      {/*Modal de edicion de clase */}
      {showClassForm && (
        <ModalStructure handleCloseModal={() => setShowClassForm(false)}>
          <ProductClassForm
            handleClose={() => setShowClassForm(false)}
            prevData={info}
            loadToParent={loadToParent}
          />
        </ModalStructure>
      )}
    </>
  );
};

export default ProductClassCard;
